// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import BarChart from "@material-ui/icons/BarChart";
import Close from "@material-ui/icons/Close";
import DateRange from "@material-ui/icons/DateRange";
import Edit from "@material-ui/icons/Edit";
import Person from "@material-ui/icons/Person";
import Star from '@material-ui/icons/Star';
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import moment from 'moment';
import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import {Helmet} from 'react-helmet'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import UserButton from 'components/CustomButtons/UserButton'

// import { dataTable } from "variables/general.js";


const useStyles = makeStyles(styles);
function ReviewsSection(props) {

  const dispatch = useDispatch();
  // useEffect(() => {
  //   // console.log("again")
  //   dispatch(fetchReviewData());
  // }, []);

  const reviews = useSelector(state => state.instructor.reviews);
  const dashboard = useSelector(state => state.instructor.dashboard);
  const instructor = useSelector(state => state.instructor.instructor);

  var viewModel = {
    totalBookings: dashboard.reservationsCount ?? "loading",
    lastThirtyRevenue: (dashboard.lastThirtyRevenue ?? 0) / 100,
    lastThirtyViews: dashboard.lastThirtyViews ?? 0,
    ratingOverall: instructor.ratingOverall ?? "loading",
    numberOfRatings: instructor.numberOfRatings ?? 0,
    lastUpdatedTimestamp: dashboard.lastUpdatedTimestamp ?? 0,
    pageViews: "Coming Soon"
  }
  // console.log(state.reservation.reservations.length)

  const classes = useStyles();
  const buttons = [
    { color: "info", icon: Person },
    { color: "success", icon: Edit },
    { color: "danger", icon: Close }
  ].map((prop, key) => {
    return (
      <Button color={prop.color} className={classes.actionButton} key={key}>
        <prop.icon className={classes.icon} />
      </Button>
    );
  });
  const lastUpdatedFromTimestamp = timestamp => {
    if (!timestamp) {
      return "Loading..."
    }
    return moment(timestamp).fromNow();
  };

  return (
    <div className="ReviewsSection container">
      <Helmet>
        <title>Testimonials</title>
      </Helmet>
      <div className='d-flex d-row justify-content-between align-items-center mb-4'>
        <h2 className="font-weight-bold">Testimonials</h2>
        {/* <NewOfferingButton className="float-right" {...props}/> */}
      </div>
      <GridContainer>
        {/* <GridItem xs={12} sm={6} md={6} lg={3}>
          <Card>
            <CardHeader color="navy" stats icon>
              <CardIcon color="navy">
              <BarChart/>
              </CardIcon>
              <p className={classes.cardCategory}>Page Views</p>
              <h3 className={classes.cardTitle}>
                {viewModel.pageViews}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                All Time
              </div>
            </CardFooter>
          </Card>
        </GridItem> */}
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Star/>
              </CardIcon>
              <p className={classes.cardCategory}>Average Rating</p>
              <h3 className={classes.cardTitle}>
                {String(Math.round((viewModel.ratingOverall || 0) * 100) / 100)}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                All Time
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={6} lg={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Star/>
              </CardIcon>
              <p className={classes.cardCategory}>Number of Reviews</p>
              <h3 className={classes.cardTitle}>
                {viewModel.numberOfRatings}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
              <DateRange />
                All Time
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} lg={12}>
          <Card>
            {/* <CardHeader color="primary" icon>
              <h4 className={classes.cardIconTitle}>Testimonials</h4>
            </CardHeader> */}
            <Tabs>
              <Tab eventKey="testimonials" title="Testimonials">
                <CardBody>
                  <Table
                    tableHead={["Name","Rating","Public Review","Date"]}
                    tableData={
                      reviews.filter(val => val.ratingOverall > 3).map(val => {
                        var rowData = [];
                        // rowData.push(val.authorFirstName !== "" ? val.authorFirstName : (val.isAnonymous ? "Anonymous" : "Unknown")) 
                        rowData.push(<UserButton 
                          user={{
                            firstName: val.authorFirstName,
                            lastName: val.authorLastName,
                            platformID: val.authorUserID
                          }}
                          />)
                        rowData.push(val.ratingOverall)
                        rowData.push((val.text !== "") ? val.text : "Star rating only")
                        rowData.push(moment(val.timestamp * 1000).format("dddd, MMMM Do YYYY, ~ha"))
                        return rowData;
                      })
                    }
                    
                    customCellClasses={[
                      classes.left,
                      classes.center,
                      classes.right
                    ]}
                    
                    customClassesForCells={[0, 3, 4]}
                    customHeadCellClasses={[
                      classes.left,
                      classes.center,
                      classes.right
                    ]}
                    
                    customHeadClassesForCells={[0, 3, 4]}
                  />
                </CardBody>
              </Tab>
              <Tab eventKey="feedback" title="Private Feedback">
                <CardBody>
                  <Table
                    tableHead={["Name","Rating","Private Message","Date"]}
                    tableData={
                      reviews.filter(val => val.ratingOverall <= 3).map(val => {
                        var rowData = [];
                        // rowData.push(val.authorFirstName !== "" ? val.authorFirstName : (val.isAnonymous ? "Anonymous" : "Unknown")) 
                        rowData.push(<UserButton 
                          user={{
                            firstName: val.authorFirstName,
                            lastName: val.authorLastName,
                            platformID: val.authorUserID
                          }}
                          />)
                        rowData.push(val.ratingOverall)
                        rowData.push(val.feedbackNote)
                        rowData.push(moment(val.timestamp * 1000).format("dddd, MMMM Do YYYY, ~ha"))
                        return rowData;
                      })
                    }
                    
                    customCellClasses={[
                      classes.left,
                      classes.center,
                      classes.right
                    ]}
                    
                    customClassesForCells={[0, 3, 4]}
                    customHeadCellClasses={[
                      classes.left,
                      classes.center,
                      classes.right
                    ]}
                    
                    customHeadClassesForCells={[0, 3, 4]}
                  />
                </CardBody>
              </Tab>

            </Tabs>
          </Card>
        </GridItem>
      </GridContainer>

    </div>
  );
}

export default ReviewsSection;
